import { addNewAddress, editAddress, queryProvinceList, queryCityList, queryAreaList } from '@/apis/address';

export default {
  data:()=>({
    addressForm: {
      // 收货人姓名
      name: '',
      // 联系方式
      phone: '',
      // 详细地址
      detail: '',
      // 省
      province_id: '',
      // 市
      city_id: '',
      // 省
      area_id: '',
      //是否默认地址。1：是。2：否
      is_default: true,
    },
    provinces: [],
    citys: [],
    areas: [],
    // 省
    province_name: '',
    // 市
    city_name: '',
    // 省
    area_name: '',
    // 修改密码地址
    isChangeAddress: false,
  }),
  methods: {
    // 新增地址信息
    submitNewAddress(){
      const { 
        $useMessage, addressForm, $router
      } = this;
      const { name, phone, detail, province_id, city_id, area_id, is_default } = addressForm;
      
      if(!name) return $useMessage({ type: 'error', message: '请填写收货人姓名' })
      if(!phone) return $useMessage({ type: 'error', message: '请填写联系方式' })
      if(!province_id) return $useMessage({ type: 'error', message: '请选择省份' })
      if(!city_id) return $useMessage({ type: 'error', message: '请选择城市' })
      if(!area_id) return $useMessage({ type: 'error', message: '请选择地区' })
      if(!detail) return $useMessage({ type: 'error', message: '请填写详细地址' })
      addNewAddress({
        ...addressForm,
        is_default: is_default ? 1 : 2,
      }).then(() =>{
        $useMessage({ type: 'success', message: '添加成功' });
        setTimeout(()=>{
          $router.go(-1)
        }, 3000)
      })
    },
    // 保存修改的地址信息
    saveEditAddress(){
      const { 
        $useMessage, addressForm, showMobileComponent, $router
      } = this;
      const { name, phone, detail, province_id, city_id, area_id, is_default,  } = addressForm;
      if(!name) return $useMessage({ type: 'error', message: '请填写收货人姓名' })
      if(!phone) return $useMessage({ type: 'error', message: '请填写联系方式' })
      if(!province_id) return $useMessage({ type: 'error', message: '请选择省份' })
      if(!city_id) return $useMessage({ type: 'error', message: '请选择城市' })
      if(!area_id) return $useMessage({ type: 'error', message: '请选择地区' })
      if(!detail) return $useMessage({ type: 'error', message: '请填写详细地址' })
      editAddress({
        ...addressForm,
        is_default: is_default ? 1 : 2,
      }).then(() =>{
        $useMessage({ type: 'success', message: '编辑成功' });
        localStorage.removeItem('addressForm');
        this.$emit('changeAddressvisible', false);
        this.$emit('remoteAddress')
        // 手机端会跳转页面所以要返回上一页
        showMobileComponent && $router.go(-1); 
      })
    },
    // PC 获取省list
    handleFocusProvince(isReset){
      return new Promise((resolve)=>{
        // 没有省列表时再请求
        this.provinces.length < 1 && queryProvinceList().then(({result})=>{
          this.provinces = result;
          if(isReset){
            this.citys = [];
            this.areas = [];
            this.addressForm.city_id = '';
            this.addressForm.city_name = '';
            this.addressForm.area_id = '';
            this.addressForm.area_name = [];
          }
          resolve(result)
        })
      })
    },
    // 切换省份
    handleChangeProvince(){
      // 初始化
      this.citys = [];
      this.areas = [];
      this.addressForm.city_id = '';
      this.addressForm.city_name = '';
      this.addressForm.area_id = '';
      this.addressForm.area_name = [];
      this.handleFocusCity();
    },
    // 切换省份
    handleChangeCity(){
      // 初始化
      this.areas = [];
      this.addressForm.area_id = '';
      this.addressForm.area_name = [];
      this.handleFocusArea();
    },
    // PC 获取市list
    handleFocusCity(){
      const { addressForm } = this;
      if(!addressForm.province_id) return this.$useMessage({ type: 'error', message: '请先选择所在省份' })
      return new Promise((resolve)=>{
        queryCityList({
          province_id: addressForm.province_id
        }).then(({result})=>{
          this.citys = result;
          resolve(result)
        })
      })
    },
    // .获取地区
    handleFocusArea(){
      const { addressForm } = this;
      if(!addressForm.city_id) return this.$useMessage({ type: 'error', message: '请先选择所在城市' })
      return new Promise(()=>{
        queryAreaList({
          city_id: addressForm.city_id
        }).then(({result})=>{
          this.areas = result
        })
      })
    },
  }
}